import React, { useState, useEffect } from "react";

import Table from "components/Table";
import Filter from "@Components/Filter";
import eightAxios from "configs/axiosConfig";
import { MESSAGE_SETTINGS_URL } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";
import ConfirmDialog from "@Components/ConfirmDialog";
import { useTranslation } from "react-i18next";

let model = [
  { id: "module", label: "Module", type: "string" },
  { id: "event_name", label: "Event", type: "string" },
  { id: "type_name", label: "Type", type: "string" },
  { id: "status", label: "Status", type: "string" },
];

const actions = ["edit"];
const detailURL = "/message-settings/details/";
const setDefaultURL = "/message-settings/set-defaults/";
const fieldsEnum = Object.freeze({
  TYPES: 1,
  MODULES: 2,
  EVENTS: 3,
  STATUSES: 4,
});

const MessageSettings = () => {
  const { t } = useTranslation();
  const setNotify = useNotifyContext();
  const [filterValues, setFilterValues] = useState({});
  const [types, setTypes] = useState([]);
  const [modules, setModules] = useState([]);
  const [events, setEvents] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const pageNumberDropdown = true;

  const filterFields = [
    {
      type: "reactselect",
      label: "Module",
      name: "module",
      outerOptions: modules,
    },
    {
      type: "reactselect",
      label: "Event",
      name: "event_name",
      outerOptions: events,
    },
    {
      type: "reactselect",
      label: "Type",
      name: "type",
      outerOptions: types,
    },
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      outerOptions: statuses,
    },
  ];

  const filterInitialValues = {
    module: "",
    event_name: "",
    type: "",
    status: "",
  };

  const handleSetDefault = () => {
    setLoading(true);
    eightAxios
      .post(setDefaultURL)
      .then((response) => {
        setLoading(false);
        setNotify({
          isOpen: true,
          message: response.data.message,
          type: "success",
        });
        fetchDetails();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
      })
      .catch((error) => {
        setLoading(false);
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        fetchDetails();
      });
  };

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const actionBarButtons = [
    {
      color: "primary",
      buttonLabel: "Set Back Default Message",
      onClick: () => {
        setConfirmDialog({
          ...confirmDialog,
          isOpen: true,
          title: t(
            "Are you sure want to return back the message setting to the original default value?"
          ),
          subTitle: "YOU CANNOT UNDO THIS OPERATION",
          onConfirm: () => {
            handleSetDefault();
          },
        });
      },
    },
  ];

  const mapValues = (values, field) => {
    let keys = Object.keys(values);
    let tempValues = [];
    let cnt = 0;
    keys.forEach((key) => {
      tempValues[cnt] = { id: values[key], name: values[key] };
      cnt++;
    });

    if (field === fieldsEnum.TYPES) {
      setTypes(tempValues);
    } else if (field === fieldsEnum.MODULES) {
      setModules(tempValues);
    } else if (field === fieldsEnum.EVENTS) {
      setEvents(tempValues);
    } else if (field === fieldsEnum.STATUSES) {
      setStatuses(tempValues);
    } else {
      // pass
    }
  };

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.modules) {
            mapValues(response.data.modules, fieldsEnum.MODULES);
          }
          if (response.data.types) {
            mapValues(response.data.types, fieldsEnum.TYPES);
          }
          if (response.data.events) {
            mapValues(response.data.events, fieldsEnum.EVENTS);
          }
          if (response.data.statuses) {
            mapValues(response.data.statuses, fieldsEnum.STATUSES);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL={MESSAGE_SETTINGS_URL}
        model={model}
        actions={actions}
        exportUrl="url"
        filterValues={filterValues}
        actionBarButtons={actionBarButtons}
        noAddButton
        noFilter
        pageNumberDropdown={pageNumberDropdown}

      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );
};
export default MessageSettings;
